import React, { useMemo } from 'react';
import styled from 'styled-components';
import { useAuth } from '../../../contexts/AuthContext';
import { useLocation } from 'react-router-dom';
import MyHeader from '../../../components/common/admin/MyHeader';
import WorkAssessmentResultsPanel from '../TeamDynamics/WorkAssessmentResultsPanel';

const AdminWorkAssessment = () => {
    const location = useLocation();
    const { groupIndex, groups } = location.state || {};
    const { groupInfo, groupMembers: authGroupMembers } = useAuth();
    const currentGroup = groups?.[groupIndex];

    // Stable reference — prevents child useEffect from re-firing when parent re-renders
    const groupMembers = useMemo(
        () => currentGroup?.members || authGroupMembers || [],
        [currentGroup?.members, authGroupMembers]
    );

    return (
        <>
            <MyHeader groupIndex={groupIndex} groups={groups} />
            <PageWrapper>
                <WorkAssessmentResultsPanel
                    groupId={groupInfo?.groupId}
                    groupMembers={groupMembers}
                />
            </PageWrapper>
        </>
    );
};

const PageWrapper = styled.div`
    background-color: #fff;
    display: flex;
    flex-direction: column;
    padding: 15px 20px 80px;
    min-height: 100vh;
`;

export default AdminWorkAssessment;
